import './DialogTraiterInterruption.scss';

import CloseIcon from '@mui/icons-material/Close';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import {AppBar, Button, Dialog, IconButton, Toolbar } from '@mui/material';
//import moment from 'moment';
import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';

import useWindowSize from '../../hooks/useWindowSize';
import { formatDateJJMMYYYY } from '../../Utils/dateFormatter';
import { buttonStyles, buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
import { DatePickerComponent, TextFieldComponent,Transition} from '../shared/ReusableSmallComponents';
import DialogAccepterIntteruptionOrAnnulerMission from './DialogAccepterIntteruptionOrAnnulerMission';
import DialogRejetIntteruption from './DialogRejetIntteruption';

function DialogTraiterInterruption({interruption,openNestedInttreption, handleCloseNestedInterruption,getInterruptionMission}) {
    DialogTraiterInterruption.propTypes = {
        interruption: PropTypes.any,
        openNestedInttreption: PropTypes.any,
        handleCloseNestedInterruption: PropTypes.func,
        getInterruptionMission:PropTypes.func,
    };

    const [dateEffectif, setDateEffectif] = useState(null);
    const [motifInterruption,setMotifInterruption]=useState('');
    const [missionId,setMissionId]=useState('');
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    //! hooks rule : call a hook only inside a functionnal component, don't try to create a function to prevent DRY ..
    //const { setBackdropOpen, setOpenSnackBar, setSnackBarMessage } = useUtilities();
    //const axiosPrivate = useAxiosPrivate();
    //const {setSnackBarMessage}=useUtilities();
    const [openDialogRejet,setOpenDialogRejet]=useState(false);
    const [openDialogAccepter,setOpenDialogAccepter]=useState(false);

    useEffect(() => {
        setDateEffectif(interruption?.dateEffectiveIso);
        setMotifInterruption(interruption?.motifInterruption);
        setMissionId(interruption?.id);
    },[interruption]);

    return (
        <>
            <Dialog
                open={openNestedInttreption}
                onClose={handleCloseNestedInterruption}
                fullScreen
                TransitionComponent={Transition}
                PaperProps={{
                    style: {
                        background: '#FFFFFF',
                    },
                }}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <AppBar>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleCloseNestedInterruption}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center',alignItems:'center' ,minHeight:'900px',height:'100%', paddingBottom: '24px',paddingTop:device=='desktop'?'0px':'235px'}}>
                    <div className='frame18ValiderDemandeIntter'>
                        <div className='frame0ValiderDemandeIntter'>
                            <h5 className='frame1ValiderDemandeIntter'>{i18n.t('Demande d\'interruption de mission')}</h5>
                            <div
                                style={{display:'flex',
                                    flexDirection: device=='desktop'?'row':'column',
                                    justifyContent: 'space-between',
                                    gap:'13px',
                                    width:device=='desktop'?'auto':'100%',
                                }}
                            >

                                <div className='frame2ValiderDemandeIntter'>
                                    <p className='frame3ValiderDemandeIntter'>
                                        {i18n.t(' du demandeur')}
                                    </p>
                                    <div className='frame4ValiderDemandeIntter'>
                                        <p className='frame19ValiderDemandeIntter'>{interruption?.demandeur}</p>
                                    </div>
                                </div>

                                <div className='frame5ValiderDemandeIntter'>
                                    <p className='frame3ValiderDemandeIntter'>
                                        {i18n.t('Référence de  la mission')}
                                    </p>
                                    <div className='frame4ValiderDemandeIntter'>
                                        <p className='frame19ValiderDemandeIntter'>{interruption?.missionId}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='frame6ValiderDemandeIntter'>
                            <div className='frame7ValiderDemandeIntter'>
                                <div className='frame8ValiderDemandeIntter'>
                                    <div className='OrdreMissionFileFrame23'>
                                        <p className='OrdreMissionFileFrame24'>{i18n.t('Intitulé de l\'AO')}</p>
                                    </div>
                                    <div className='OrdreMissionFileFrame25'>
                                        <TextFieldComponent
                                            name="intituleAo"
                                            value={interruption?.titre}
                                            //onChange={(e) => setMotifInterruption(e.target.value)}
                                            sx={{
                                                '& > :not(style)': {borderRadius: '8px'},
                                            }}
                                            style={{width:'100%'}}
                                            //defaultValue=""
                                            autoFocus={true}
                                            disabled
                                        // ref={userRef}
                                        //value={email}
                                        />
                                    </div>
                                </div>
                                <div className='frame14ValiderDemandeIntter'>
                                    <div
                                        className='frame4DialogVisualiserDocument'
                                        style={{width:device=='desktop'?'50%':'100%'}}
                                    >
                                        <p className='frame5DialogVisualiserDocument'>{i18n.t('Nom du client')}</p>
                                        <TextFieldComponent
                                            name="nomClient"
                                            value={interruption?.nomClient}
                                            //onChange={(e) => setMotifInterruption(e.target.value)}
                                            sx={{
                                                '& > :not(style)': {borderRadius: '8px'},
                                            }}
                                            style={{width:'100%'}}
                                            disabled
                                            //defaultValue=""
                                            autoFocus={true}
                                        />
                                    </div>
                                    <div
                                        className='frame4DialogVisualiserDocument'
                                        style={{width:device=='desktop'?'50%':'100%'}}
                                    >
                                        <p className='frame5DialogVisualiserDocument'>{i18n.t('Réf. Client')}</p>
                                        <TextFieldComponent
                                            name="refClient"
                                            value={interruption?.collaboratorId}
                                            //onChange={(e) => setMotifInterruption(e.target.value)}
                                            sx={{
                                                '& > :not(style)': {borderRadius: '8px'},
                                            }}
                                            style={{width:'100%'}}
                                            disabled
                                            //defaultValue=""
                                            autoFocus={true}
                                            // ref={userRef}
                                            //value={email}
                                        />
                                    </div>
                                    {/*<div className='frame14ValiderDemandeIntter'>
                                        <p className='frame15ValiderDemandeIntter'>Nom du client</p>
                                        <p className='frame16ValiderDemandeIntter'>Réf. Client</p>
                                    </div>
                                    <div className='frame17ValiderDemandeIntter'>
                                        <TextFieldComponent
                                            name="nomClient"
                                            value={interruption?.nomClient}
                                            //onChange={(e) => setMotifInterruption(e.target.value)}
                                            sx={{
                                                '& > :not(style)': { width: '371px',borderRadius: '8px'},
                                            }}
                                            disabled
                                            //defaultValue=""
                                            autoFocus={true}
                                        />
                                        <TextFieldComponent
                                            name="refClient"
                                            value={interruption?.collaboratorId}
                                            //onChange={(e) => setMotifInterruption(e.target.value)}
                                            sx={{
                                                '& > :not(style)': { width: '371px',borderRadius: '8px'},
                                            }}
                                            disabled
                                            //defaultValue=""
                                            autoFocus={true}
                                        // ref={userRef}
                                        //value={email}
                                        />
                                    </div>
                                    */}
                                </div>
                                <div className='frame14ValiderDemandeIntter'>
                                    <div
                                        className='frame4DialogVisualiserDocument'
                                        style={{width:device=='desktop'?'50%':'100%'}}
                                    >
                                        <p className='frame5DialogVisualiserDocument'>{i18n.t('Nom de l\'Expert')}</p>
                                        <TextFieldComponent
                                            name="nomExpert"
                                            value={interruption?.nomExpert}
                                            //onChange={(e) => setMotifInterruption(e.target.value)}
                                            sx={{
                                                '& > :not(style)': {borderRadius: '8px'},
                                            }}
                                            style={{width:'100%'}}
                                            disabled
                                            //defaultValue=""
                                            autoFocus={true}
                                            // ref={userRef}
                                            //value={email}
                                        />
                                    </div>

                                    <div
                                        className='frame4DialogVisualiserDocument'
                                        style={{width:device=='desktop'?'50%':'100%'}}
                                    >
                                        <p className='frame5DialogVisualiserDocument'>{i18n.t('Réf. Expert')}</p>
                                        <TextFieldComponent
                                            name="refExpert"
                                            value={interruption?.expertId}
                                            //onChange={(e) => setMotifInterruption(e.target.value)}
                                            sx={{
                                                '& > :not(style)': {borderRadius: '8px'},
                                            }}
                                            style={{width:'100%'}}
                                            disabled
                                            //defaultValue=""
                                            autoFocus={true}
                                            // ref={userRef}
                                            //value={email}
                                        />
                                    </div>
                                    {/*<div className='frame14ValiderDemandeIntter'>
                                        <p className='frame15ValiderDemandeIntter'>Nom de l&apos;Expert</p>
                                        <p className='frame16ValiderDemandeIntter'>Réf. Expert</p>
                                    </div>
                                    <div className='frame17ValiderDemandeIntter'>
                                        <TextFieldComponent
                                            name="nomExpert"
                                            value={interruption?.nomExpert}
                                            //onChange={(e) => setMotifInterruption(e.target.value)}
                                            sx={{
                                                '& > :not(style)': { width: '371px',borderRadius: '8px'},
                                            }}
                                            disabled
                                            //defaultValue=""
                                            autoFocus={true}
                                        // ref={userRef}
                                        //value={email}
                                        />
                                        <TextFieldComponent
                                            name="refExpert"
                                            value={interruption?.expertId}
                                            //onChange={(e) => setMotifInterruption(e.target.value)}
                                            sx={{
                                                '& > :not(style)': { width: '371px',borderRadius: '8px'},
                                            }}
                                            disabled
                                            //defaultValue=""
                                            autoFocus={true}
                                        // ref={userRef}
                                        //value={email}
                                        />
                                    </div>*/}
                                </div>
                                <div className='frame14ValiderDemandeIntter'>
                                    <div
                                        className='frame4DialogVisualiserDocument'
                                        style={{width:device=='desktop'?'50%':'100%'}}
                                    >
                                        <p className='frame5DialogVisualiserDocument'>{i18n.t('Date de demande')}</p>
                                        <TextFieldComponent
                                            name="dateDemande"
                                            value={formatDateJJMMYYYY(interruption?.dateDemande)}
                                            //onChange={(e) => setMotifInterruption(e.target.value)}
                                            sx={{
                                                '& > :not(style)': {borderRadius: '8px'},
                                            }}
                                            style={{width:'100%'}}
                                            disabled
                                            //defaultValue=""
                                            autoFocus={true}
                                            // ref={userRef}
                                            //value={email}
                                        />
                                    </div>

                                    <div
                                        className='frame4DialogVisualiserDocument'
                                        style={{width:device=='desktop'?'50%':'100%'}}
                                    >
                                        <p className='frame5DialogVisualiserDocument'>{i18n.t('Date effective de l\'interruption(souhaitée)')}</p>
                                        <DatePickerComponent
                                            date={dateEffectif}
                                            setDate={(newValue) => {
                                                setDateEffectif(newValue);
                                            }}
                                            width={'100%'}
                                            disabled
                                        />
                                    </div>
                                    {/*<div className='frame14ValiderDemandeIntter'>
                                        <p className='frame15ValiderDemandeIntter'>Date de demande</p>
                                        <p className='frame16ValiderDemandeIntter'>Date effective de l&apos;interruption(souhaitée)</p>
                                    </div>*/}
                                    {/*<div className='frame17ValiderDemandeIntter'>
                                        <TextFieldComponent
                                            name="dateDemande"
                                            value={formatDateJJMMYYYY(interruption?.dateDemande)}
                                            //onChange={(e) => setMotifInterruption(e.target.value)}
                                            sx={{
                                                '& > :not(style)': { width: '371px',borderRadius: '8px'},
                                            }}
                                            disabled
                                            //defaultValue=""
                                            autoFocus={true}
                                        // ref={userRef}
                                        //value={email}
                                        />
                                        <DatePickerComponent
                                            value={dateEffectif}
                                            onChange={(newValue) => {
                                                setDateEffectif(newValue?.utc().add(moment().utcOffset(), 'minutes'));
                                            }}
                                            width={371}
                                            disabled
                                        />
                                    </div>*/}
                                </div>
                            </div>
                            <div className='frame12ValiderDemandeIntter'>
                                <div className='OrdreMissionFileFrame23'>
                                    <p className='OrdreMissionFileFrame24'>{i18n.t('Motif de l\'interruption')} </p>
                                </div>
                                <div className='OrdreMissionFileFrame27'>
                                    <TextFieldComponent
                                        name="motifInterr"
                                        multiline
                                        minRows={4}
                                        dateDemande
                                        disabled
                                        value={motifInterruption}
                                        onChange={(e) => setMotifInterruption(e.target.value)}
                                        sx={{
                                            '& > :not(style)': {borderRadius: '8px'},
                                        }}
                                        style={{width:'100%'}}
                                        //defaultValue=""
                                        autoFocus={true}
                                    // ref={userRef}
                                    //value={email}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='frame13ValiderDemandeIntter'>
                            <Button
                                onClick={()=>{setOpenDialogRejet(true);}}
                                variant="text"
                                style={{...buttonStyles(),
                                    ...{
                                        borderColor:'#EC5B56',color:'#EC5B56',width:device=='desktop'?'119px':'100%'}
                                }}
                                startIcon={<EventBusyIcon />}

                            >{i18n.t('Rejeter')}</Button>
                            <Button
                                variant="contained"
                                style={{...buttonStylesGreen(false),...{width:device=='desktop'?'119px':'100%'}}}
                                onClick={()=>{
                                    //accepterDemande();
                                    setOpenDialogAccepter(true);
                                }}
                                //</div>onClick={()=> switchPropositionCommerciale('reject')}
                            >{i18n.t('Accepter')}</Button>
                        </div>
                    </div>
                </div>
            </Dialog>

            <DialogRejetIntteruption
                handleCloseDialogRejet={() => {
                    setOpenDialogRejet(false);
                }}
                handleCloseDialogWithChangesTable={()=>{
                    setOpenDialogRejet(false);
                    handleCloseNestedInterruption();
                    getInterruptionMission();
                }}
                openDialogRejet={openDialogRejet}
                missionId={missionId}
                dateEffective={dateEffectif}
            />
            <DialogAccepterIntteruptionOrAnnulerMission
                handleCloseDialogAccept={() => {
                    setOpenDialogAccepter(false);
                }}
                handleCloseAncienDialog={handleCloseNestedInterruption}
                getIntteruption={getInterruptionMission}
                openDialogAccept={openDialogAccepter}
                missionId={missionId}
            />
        </>
    );
}

export default DialogTraiterInterruption;